import React, { useEffect, useState } from "react";
import { ContractSideBar, Header } from "../../Elements";
import { assetsType, displayDateFormatShort, displayDateTimeFormatShort } from "../../../../constants";
import { sExportContractsAc } from "../../../../shared/actionCreators";
import { connect } from "react-redux";
import { ListLoader } from "../../../../shared";
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, Button, Grid, TablePagination, Typography } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { useSnackbar } from "notistack";
import { globalGetService, globalPostService } from "../../../../utils_v2/globalApiServices";
import { checkApiStatus } from "../../../../utils_v2";
import { STableLoader } from "../../../../shared_elements/loaders";
import { browserHistory } from "react-router";
import { EmptyCollection, PageLoader, FilterComponent } from "../../../../shared_elements";
import QuickBook from "./QuickBook";
import moment from "moment";

const filterMenu = {
  company_name: { inputType: 'text', title: 'Company Name' },
  // company_id: { inputType: 'text', title: 'Company ID' },
};

const QbProductService = ({ params, contractSummaryLoader }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [productServices, setproductServices] = useState({ list: [], pagination: null });
  const [filter, setFilter] = useState({});
  const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
  useEffect(() => {
    getProductAndServices({}, 'skeletonLoader');
  }, []);

  const getProductAndServices = (query = {}, loaderType) => {
    loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
    globalGetService(`/contracts/product_and_services/`, query)
      .then(response => {
        if (checkApiStatus(response)) {
          setproductServices(response.data.data);
          setFilter(query)
        }
        loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
      });
  };

  const createSortHandler = (key, defaultOrder = 'asc') => {
    let sortQuery = { sort: key };
    if (sortInfo.sort === key) {
      sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
    } else {
      sortQuery = { ...sortQuery, sort_by: defaultOrder }
    }
    setSortInfo(sortQuery)
    getProductAndServices({ ...filter, ...sortQuery, page: 1, per_page: productServices?.pagination?.per_page || 10 }, 'pageLoader');
  }

  const getThirdPartyApp = (sync) => {
    localStorage.setItem('thirdPartyProductState', sync);
    setLoading(true)
    globalGetService(`contracts/app-plugin/quickbooks/authenticate/`)
      .then(response => {
        if (checkApiStatus(response)) {
          window.open(response.data?.data?.url, '_blank');
          setLoading(false)
        }
      })
      .catch(() => {
        enqueueSnackbar('Error syncing with QuickBooks', { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
      });
  };
  const getThirdParty = (data) => {
    getThirdPartyApp(data)
  };

  const { page, per_page, sort: _s, sort_by: _sb, ...appliedFilter } = filter;

  return (
    <div className="fleet-lease-management-sec" >
      {contractSummaryLoader ? <ListLoader /> : null}
      <QuickBook currentPath={window.location.href} />
      {skeletonLoader ? <STableLoader count={8} /> :
        <div>
          <Paper square style={{ padding: '4px 8px' }}>
            <Grid container spacing={1} alignItems="center">
              <Grid item md={9}>
                <FilterComponent
                  filter={appliedFilter}
                  filterMenu={filterMenu}
                  getResponseBack={(applyFilter) => { getProductAndServices({ ...applyFilter, page: 1, per_page: productServices?.pagination?.per_page || 10 }, 'pageLoader') }}
                />
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#9439e4' }}> Last Synced by:{" "} <span style={{ fontSize: '12px', fontWeight: 'normal' }}> {productServices?.list?.[0]?.qb_last_sync_by?.name ? `${productServices.list[0].qb_last_sync_by.name} (${productServices.list[0].qb_last_sync_time ? moment(productServices.list[0].qb_last_sync_time).format(displayDateFormatShort) : '--'})` : '--'} </span> </Typography>
              </Grid>
              <Grid item md={3}>
                <ul className="list-inline flex-centered" style={{ float: 'right' }}>
                  <li className="list-inline-item">
                    <Button variant="contained" size="small" onClick={() => getThirdParty('SyncProductService')} color="primary"> sync Product & Services</Button>
                  </li>
                </ul>
              </Grid>
            </Grid>
          </Paper>
          <Paper style={{ overflow: "auto", maxHeight: `${window.innerHeight - 230}px` }}>
            <Table className="mui-table-format" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell sortDirection={sortInfo.sort === 'name' ? sortInfo.sort_by : false}>
                    <div style={{ width: '250px' }}>
                      <TableSortLabel active={sortInfo.sort === 'name' ? true : false} direction={sortInfo.sort === 'name' ? sortInfo.sort_by : 'asc'} onClick={() => createSortHandler('name')}>
                        Name
                      </TableSortLabel>
                    </div>
                  </TableCell>
                  <TableCell><div style={{ width: '220px' }}>Sku</div></TableCell>
                  <TableCell sortDirection={sortInfo.sort === 'type' ? sortInfo.sort_by : false}>
                    <div style={{ width: '200px' }}>
                      <TableSortLabel active={sortInfo.sort === 'type' ? true : false} direction={sortInfo.sort === 'type' ? sortInfo.sort_by : 'asc'} onClick={() => createSortHandler('type')}>
                        Type
                      </TableSortLabel>
                    </div>
                  </TableCell>
                  <TableCell><div style={{ width: '270px' }}>Sales Description</div></TableCell>
                  <TableCell sortDirection={sortInfo.sort === 'company_name' ? sortInfo.sort_by : false}>
                    <div style={{ minWidth: '100px' }}>
                      <TableSortLabel active={sortInfo.sort === 'company_name' ? true : false} direction={sortInfo.sort === 'company_name' ? sortInfo.sort_by : 'asc'} onClick={() => createSortHandler('company_name')}>
                        Company Name
                      </TableSortLabel>
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productServices.list.map((item, index) =>
                  <TableRow key={index}>
                    <TableCell>
                      <div style={{ width: '250px' }}>{item?.name || '--'}</div>
                    </TableCell>
                    <TableCell>
                      <div style={{ width: '220px' }}>{item?.sku || '--'}</div>
                    </TableCell>
                    <TableCell>
                      <div style={{ width: '200px' }}>{item?.type || '--'}</div>
                    </TableCell>
                    <TableCell>
                      <div style={{ width: '270px' }}>{item?.description || '--'}</div>
                    </TableCell>
                    <TableCell>
                      <div style={{ minWidth: '100px' }}>{item?.company_name || '--'}</div>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </Paper>
          {productServices.list?.length ?
            <Paper>
              <TablePagination
                rowsPerPageOptions={[10, 20, 50, 100, 200, 300, 400, 500]}
                component="div"
                count={productServices?.pagination?.total}
                rowsPerPage={productServices?.pagination?.per_page}
                page={productServices.pagination?.page - 1}
                backIconButtonProps={{ 'aria-label': 'previous page' }}
                nextIconButtonProps={{ 'aria-label': 'next page' }}
                onChangePage={(event, newPage) => getProductAndServices({ ...filter, page: newPage + 1, per_page: productServices.pagination.per_page, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort  }, 'pageLoader')}
                onChangeRowsPerPage={(event) => getProductAndServices({ ...filter, page: 1, per_page: event.target.value, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort  }, 'pageLoader')}
              />
            </Paper> : null}
        </div>}
      <Paper>
        {!productServices.list?.length && !skeletonLoader ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
      </Paper>
      {isLoading ? <PageLoader /> : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  contractSummaryLoader: state.sharedReducers.contractSummaryLoader,
});

const mapDispatchToProps = (dispatch) => ({
  exportContract: (contract_slug) => dispatch(sExportContractsAc(contract_slug)),
});

export default connect(mapStateToProps, mapDispatchToProps)(QbProductService);
